export default {
    VALOR: 1,
    QUANTIDADE: 2
}